import React from 'react';
import cn from 'classnames';
import propTypes from 'prop-types';

import { i18n } from '../../unit/const';
import store from '../../store';
import actions from '../../actions';
import style from './index.less';

export default class Decorate extends React.Component {
  constructor() {
    super();
    this.toggleLan = this.toggleLan.bind(this);
    this.handleTouchToggle = this.handleTouchToggle.bind(this);
  }
  handleTouchToggle(e) {
    e.preventDefault();
    this.toggleLan();
  }
  shouldComponentUpdate(nextProps) {
    return nextProps.lan !== this.props.lan;
  }
  toggleLan() {
    const cur = store.getState().get('language');
    const next = cur === 'en' ? 'hk' : 'en';
    store.dispatch(actions.language(next));
    document.title = next === 'en' ? 'TETRIS' : `${i18n.title[next]} TETRIS`;
  }
  render() {
    const lan = this.props.lan;
    return (
      <div className={style.decorate}>
        <div className={style.topBorder}>
          <span className={cn(['l', style.mr])} style={{ width: 40 }} />
          <span className={cn(['l', style.mr])} />
          <span className={cn(['l', style.mr])} />
          <span className={cn(['l', style.mr])} />
          <span className={cn(['l', style.mr])} />
          <span className={cn(['r', style.ml])} style={{ width: 40 }} />
          <span className={cn(['r', style.ml])} />
          <span className={cn(['r', style.ml])} />
          <span className={cn(['r', style.ml])} />
          <span className={cn(['r', style.ml])} />
        </div>
        <h1>{i18n.title[lan]}</h1>
        <div className={style.langToggle} onClick={this.toggleLan} onTouchStart={this.handleTouchToggle}>
          <span className={cn({ [style.active]: lan === 'hk' })}>中文</span>
          <span className={style.sep}>/</span>
          <span className={cn({ [style.active]: lan === 'en' })}>EN</span>
        </div>
        <div className={style.view}>
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <b className="c" />
          <div className="clear" />
          <em />
          <b className="c" />
          <p />
          <em />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <b className="c" />
          <div className="clear" />
          <em />
          <b className="c" />
          <p />
          <b className="c" />
          <b className="c" />
          <b className="c" />
          <b className="c" />
          <p />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <p />
          <b className="c" />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <p />
          <em />
          <b className="c" />
          <div className="clear" />
          <em />
          <b className="c" />
          <div className="clear" />
          <em />
          <b className="c" />
          <div className="clear" />
          <em />
          <b className="c" />
        </div>
        <div className={cn([style.view, style.l])}>
          <em />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <p />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <p />
          <b className="c" />
          <b className="c" />
          <b className="c" />
          <b className="c" />
          <p />
          <em />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <b className="c" />
          <div className="clear" />
          <em />
          <b className="c" />
          <p />
          <b className="c" />
          <b className="c" />
          <div className="clear" />
          <em />
          <b className="c" />
          <div className="clear" />
          <em />
          <b className="c" />
          <p />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
          <div className="clear" />
          <b className="c" />
        </div>
      </div>
    );
  }
}

Decorate.propTypes = {
  lan: propTypes.string.isRequired,
};
